/* Groovd Webkit global helpers. No framework, no jQuery. */
(function () {
  'use strict';

  function formatMoney(cents) {
    /* gw-currency.js: Shopify's market currency, or the visitor's currency with Checkout Champ's rounding */
    if (typeof window.gwFormatCents === 'function') return window.gwFormatCents(cents);
    var fmt = (window.moneyFormat || '${{amount}}');
    var amount = (cents / 100).toFixed(2);
    if (fmt.indexOf('amount_no_decimals') > -1) amount = Math.round(cents / 100).toString();
    else if (fmt.indexOf('amount_with_comma_separator') > -1) amount = amount.replace('.', ',');
    amount = amount.replace(/\B(?=(\d{3})+(?!\d))/g, fmt.indexOf('comma_separator') > -1 ? '.' : ',');
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount);
  }

  function request(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }

  /* Cart A/B test 2 (owner 17.10.2026, after test 1 'freeship' vs 'protect' ended in a tie): 'protect' = the cart shows only the
     shipping protection switch, 'both' = the free-shipping bar AND the protection switch. One coin flip per visitor, kept in
     localStorage gw_cart_test2 (a fresh flip for everyone; test 1 used gw_cart_test), made at the first add to cart or the first
     cart view. Config: window.GW_CART_TEST from layout/theme.liquid (Theme settings > Cart behaviour); split = % 'protect'.
     With the test switched off the cart shows the free-shipping bar only ('freeship').
     ENDED 22.10.2026, owner: "the free shipping bar + switch as the winner": every cart gets 'both' (tied the control, +1.0% profit
     per cart viewer); gw_cart_test2 is no longer read or written.
     QA: ?cart_test=protect, ?cart_test=both or ?cart_test=freeship forces that side for one page view (nothing saved). */
  /* Owner 14.10.2026: protection never starts switched on (Theme settings > Cart behaviour list left empty). Only a visitor's
     own tap keeps it in the cart: gw_prot_on marks that tap; a protection line without it is taken out on the cart page. */
  var CT_KEY = 'gw_cart_test2', PROT_OFF_KEY = 'gw_prot_off', PROT_ON_KEY = 'gw_prot_on';
  function ls(k, v) { try { if (v === undefined) return localStorage.getItem(k); if (v === null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch (e) {} return null; }
  function cartTest() { var c = window.GW_CART_TEST; return c && c.on && Number(c.variant) > 0 ? c : null; }
  function cartArm() {
    var forced = (/[?&]cart_test=(freeship|protect|both)(&|#|$)/.exec(location.search) || [])[1];
    if (forced) return forced;
    var c = cartTest(); if (!c) return 'freeship';
    return 'both';
  }
  /* Starts switched on only where pre-ticked paid extras are allowed: the visitor's own country (IP, from gw-currency.js) when
     known, else the Shopify market country, must be in the list. */
  function protDefaultOn() {
    var c = window.GW_CART_TEST || {}, list = c.defaultOn || [], ip = '';
    try { ip = ((JSON.parse(sessionStorage.getItem('gwVisitorCountry') || 'null') || {}).code || '').toUpperCase(); } catch (e) {}
    if (ip) return list.indexOf(ip) >= 0;
    return list.indexOf(((window.GW_LOC && window.GW_LOC.country) || '').toUpperCase()) >= 0;
  }
  function protOptedOut() { return ls(PROT_OFF_KEY) === '1'; }
  /* The protection line rides along with the first add to cart for 'protect' visitors where it starts switched on, unless they
     switched it off before or the cart already has it. */
  function withProtection(items, cleared) {
    var c = cartTest(); if (!c) return Promise.resolve(items);
    var v = Number(c.variant);
    if (items.some(function (i) { return Number(i.id) === v; })) return Promise.resolve(items);
    var arm = cartArm();
    if ((arm !== 'protect' && arm !== 'both') || !protDefaultOn() || protOptedOut()) return Promise.resolve(items);
    var has = cleared ? Promise.resolve(false) : fetch(window.routes.cart_url + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { return (cart.items || []).some(function (i) { return Number(i.variant_id) === v; }); })
      .catch(function () { return true; });
    return has.then(function (h) { return h ? items : items.concat([{ id: v, quantity: 1 }]); });
  }
  /* Cart count without the protection line (the header badge counts things the visitor bought) */
  function visibleCount(cart) {
    var c = window.GW_CART_TEST || {}, v = Number(c.variant) || -1, n = cart.item_count || 0;
    (cart.items || []).forEach(function (i) { if (Number(i.variant_id) === v || (i.properties && i.properties._gift)) n -= i.quantity; });
    return Math.max(0, n);
  }

  /* items: [{id, quantity, properties?}] */
  function addToCart(items, opts) {
    opts = opts || {};
    var chain = Promise.resolve();
    if (opts.replace) chain = chain.then(function () { return request(window.routes.cart_clear_url + '.js'); });
    return chain.then(function () {
      return withProtection(items, opts.replace).then(function (list) {
        var add = request(window.routes.cart_add_url + '.js', { items: list });
        /* never let the protection line block the visitor's own add */
        return list.length > items.length ? add['catch'](function () { return request(window.routes.cart_add_url + '.js', { items: items }); }) : add;
      });
    }).then(function (res) {
      document.dispatchEvent(new CustomEvent('cart:added', { detail: res }));
      return res;
    });
  }

  function goAfterAdd(mode) {
    if (mode === 'checkout') window.location.href = '/checkout';
    else window.location.href = window.routes.cart_url;
  }

  function reconvertCurrency() {
    if (window.bucksCC && typeof window.bucksCC.reConvert === 'function') {
      try { window.bucksCC.reConvert(); } catch (e) { /* ignore */ }
    }
  }

  window.Groovd = {
    formatMoney: formatMoney,
    addToCart: addToCart,
    goAfterAdd: goAfterAdd,
    reconvertCurrency: reconvertCurrency,
    request: request,
    cartArm: cartArm,
    protDefaultOn: protDefaultOn,
    protOptedOut: protOptedOut,
    protOptedIn: function () { return ls(PROT_ON_KEY) === '1'; },
    setProtOptOut: function (off) { ls(PROT_OFF_KEY, off ? '1' : null); ls(PROT_ON_KEY, off ? null : '1'); },
    visibleCount: visibleCount
  };

  /* Any button with data-add-variant adds that variant (qty 1) and follows the theme's after-add setting. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add-variant]');
    if (!btn) return;
    e.preventDefault();
    if (btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    addToCart([{ id: Number(btn.getAttribute('data-add-variant')), quantity: 1 }], { replace: false })
      .then(function () { goAfterAdd(btn.getAttribute('data-after-add') || 'cart'); })
      .catch(function (err) {
        btn.removeAttribute('aria-busy');
        alert((err && err.description) || 'Could not add to cart. Please try again.');
      });
  });

  /* Lightweight scroller progress bars: <div class="scroller" data-track="#id"> */
  document.querySelectorAll('.scroller[data-track]').forEach(function (sc) {
    var track = document.querySelector(sc.getAttribute('data-track'));
    if (!track) return;
    var bar = track.querySelector('b');
    function update() {
      var max = sc.scrollWidth - sc.clientWidth;
      var ratio = sc.clientWidth / sc.scrollWidth;
      bar.style.width = Math.max(ratio * 100, 8) + '%';
      bar.style.left = (max > 0 ? (sc.scrollLeft / max) * (100 - Math.max(ratio * 100, 8)) : 0) + '%';
    }
    sc.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  /* Prev/next buttons: [data-scroll-prev="#id"] / [data-scroll-next="#id"] */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-scroll-prev],[data-scroll-next]');
    if (!b) return;
    var sel = b.getAttribute('data-scroll-prev') || b.getAttribute('data-scroll-next');
    var sc = document.querySelector(sel);
    if (!sc) return;
    var dir = b.hasAttribute('data-scroll-prev') ? -1 : 1;
    sc.scrollBy({ left: dir * sc.clientWidth * 0.8, behavior: 'smooth' });
  });

  /* 19.10.2026 (Paulina: "the carousel isn't working"): with every card already in view the arrows did nothing.
     Now the arrow pair hides when its row does not scroll, and Previous / Next grey out at the start / end. */
  function arrowState() {
    document.querySelectorAll('[data-scroll-next]').forEach(function (nx) {
      var sc = document.querySelector(nx.getAttribute('data-scroll-next'));
      if (!sc) return;
      var pv = document.querySelector('[data-scroll-prev="' + nx.getAttribute('data-scroll-next') + '"]');
      var max = sc.scrollWidth - sc.clientWidth, wrap = nx.parentNode;
      if (wrap && wrap.classList.contains('arrows')) wrap.style.visibility = max > 4 ? '' : 'hidden';
      nx.disabled = sc.scrollLeft >= max - 4;
      if (pv) pv.disabled = sc.scrollLeft <= 4;
      if (!sc.__gwArrows) { sc.__gwArrows = true; sc.addEventListener('scroll', function () { window.requestAnimationFrame(arrowState); }, { passive: true }); }
    });
  }
  window.addEventListener('resize', arrowState);
  window.addEventListener('load', arrowState);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrowState); else arrowState();
})();

/* Sale date: today, written the way the CheckoutChamp landers write it for the visitor's market
   (US 10/12/2026, Sweden and Canada 2026-10-12, everyone else 12/10/2026). Fills every [data-sale-date]
   (promo bar "BUY BEFORE", the "Sale ends" note) and repaints when gw-units.js learns the country. */
(function () {
  function today() {
    var d = new Date(), D = ('0' + d.getDate()).slice(-2), M = ('0' + (d.getMonth() + 1)).slice(-2), Y = d.getFullYear();
    var c = (window.gwLocale && window.gwLocale.country) || (window.GW_LOC && window.GW_LOC.country) || 'US';
    if (c === 'US') return M + '/' + D + '/' + Y;
    if (c === 'SE' || c === 'CA') return Y + '-' + M + '-' + D;
    return D + '/' + M + '/' + Y;
  }
  function paint() { var t = today(); document.querySelectorAll('[data-sale-date]').forEach(function (el) { el.textContent = t; }); }
  window.Groovd.saleDate = today;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paint); else paint();
  document.addEventListener('gw:locale', paint);
})();

/* Visitor's country flag (header + delivery line). Liquid renders the market country; this swaps in
   the country Shopify detects from the visitor's IP, so a visitor from any country sees their own flag,
   even where that country is not a Shopify market. Cached for the session. */
(function () {
  var FLAG = 'https://cdn.shopify.com/static/images/flags/';
  function paint(code, name) {
    if (!code) return;
    document.querySelectorAll('img[data-country-flag]').forEach(function (img) {
      if (img.getAttribute('data-country-flag') === code.toLowerCase()) return;
      img.src = FLAG + code.toLowerCase() + '.svg';
      img.setAttribute('data-country-flag', code.toLowerCase());
      if (name) { img.alt = name; img.title = name; }
    });
  }
  function run() {
    var cached = null;
    try { cached = JSON.parse(sessionStorage.getItem('gwVisitorCountry') || 'null'); } catch (e) {}
    if (cached && cached.code) { paint(cached.code, cached.name); return; }
    /* gw-currency.js looks the IP country up as the page starts and announces it */
    document.addEventListener('gw:country', function (e) { paint(e.detail.code, e.detail.name); });
    if (window.gvCurrency) return;
    fetch('/browsing_context_suggestions.json?country%5Benabled%5D=true', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var c = d && d.detected_values && d.detected_values.country;
        if (!c || !c.handle) return;
        try { sessionStorage.setItem('gwVisitorCountry', JSON.stringify({ code: c.handle, name: c.name })); } catch (e) {}
        paint(c.handle, c.name);
      })
      .catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
